import React, { useEffect } from "react";
import { Box, makeStyles, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { actionTypes } from "../../../../../../../redux/bourse/select_manufacturer";


let useStyles = makeStyles((theme) => ({
    root: {
        width: "270px",
        [theme.breakpoints.down("700")]: {
            width: '100%',
        },
    },
    box: {
        margin: 10,
        [theme.breakpoints.down("700")]: {
            margin: '10px 0px',
            width: '100%',
        },
    }
}))

export default function Index({ handleChange, state }) {

    let classes = useStyles();
    let dispatch = useDispatch();

    const stateReducer = useSelector((state) => state.bourse_select_manufacturer_reducer);


    const apiSubmit = () => {

        dispatch({
            type: actionTypes.selectManufacturerBourseAsync,
            payload: state['commodity_id']?.data?.commodity_id
                ? {
                    data: {
                        commodity_id: state['commodity_id']?.data?.commodity_id
                    }
                }
                : {},
        });
    };

    useEffect(() => {

        apiSubmit();
    }, [state['commodity_id']]);


    return (
        <div className={classes['root']}>

            <Box
                className={classes['box']}
                // marginBottom="30px"
                width="250px"
                height="40px"
            >
                <Autocomplete
                    size={"small"}
                    id="combo-box-demo"
                    // disabled={stateReducer.data ? false : true}
                    options={stateReducer?.data}
                    getOptionLabel={(option) => option.id}
                    value={state?.['manufacturer_id'] ? state?.['manufacturer_id'] : null}
                    onChange={(event, value) => handleChange(value, "manufacturer_id")}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="تولید کنندگان"
                            variant="outlined"
                        />
                    )}
                />
            </Box>
        </div>)
}
